import { gql } from "apollo-boost";

export const GET_ALL_MEET_SESSIONS = gql`
  query {
    allMeetSession {
      edges {
        node {
          number
          seqno
          name
          meetId
          date
          time
          updateDate
          updateSource
        }
      }
    }
  }
`;
